import React from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

interface Props {
  label: string;
  subtext: string;
  value: number;
  onDecrement: () => void;
  onIncrement: () => void;
}

export default function PaxCounterCard({ label, subtext, value, onDecrement, onIncrement }: Props) {
  return (
    <div className="customize-tour-form__pax-card">
      <div className="customize-tour-form__pax-card-text">
        <span className="customize-tour-form__pax-card-label">{label}</span>
        <span className="customize-tour-form__pax-card-subtext">{subtext}</span>
      </div>
      <div className="customize-tour-form__pax-stepper">
        <button type="button" disabled={value <= 0} onClick={onDecrement} aria-label={`Decrease ${label}`}>
          <MinusOutlined />
        </button>
        <span className="customize-tour-form__pax-count">{value}</span>
        <button type="button" onClick={onIncrement} aria-label={`Increase ${label}`}>
          <PlusOutlined />
        </button>
      </div>
    </div>
  );
}
